import { Directive, Input, HostBinding } from '@angular/core';
import { slideToggle, slideToggleLocation } from '../helpers/slidetoggle';

@Directive({
  selector: '[appSlideToggle]',
  standalone: false
})
export class SlideToggleDirective {
  @Input('appSlideToggle') state: 'open' | 'closed' = 'closed';
  
  // IsNormal je true za sve dropdownove (ima izuzetak za location dropdown) zbog toga i postoji ovaj boolean.
  @Input() isNormal: boolean = true;

  @HostBinding('@slideToggle') get normal() {
    return this.isNormal ? '' : null;
  }

  @HostBinding('@slideToggleLocation') get location() {
    return this.isNormal ? null : this.state;
  }
}
